import {
    CREATE_JOB_YARN_RECEIVE,
    DELETE_JOB_YARN_RECEIVE,
    GET_JOB_YARN_RECEIVE,
    JOB_YARN_RECEIVE_REQUEST,
    JOB_YARN_RECEIVE_REQUEST_FAILURE,
    UPDATE_JOB_YARN_RECEIVE,
    GET_JOB_YARN_RECEIVES_PAGE,
    JOB_YARN_RECEIVE_REQUEST_SUCCESS
  } from "../types/job-yarn-receive-types";
  
  const initialState = {
    jobYarnReceive: [],
    jobYarnReceivesPage: [],
    loading: false,
    error: null,
  };
  
  const jobYarnReceiveReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOB_YARN_RECEIVE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_YARN_RECEIVE: {
        return {
          ...state,
          jobYarnReceive: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_JOB_YARN_RECEIVES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          jobYarnReceivesPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_JOB_YARN_RECEIVE:
        return {
          ...state,
          jobYarnReceive: [action.payload, ...state.jobYarnReceive],
          loading: false,
          error: null
        };
      case UPDATE_JOB_YARN_RECEIVE:
        const jobYarnReceiveData = state.jobYarnReceive.slice(0);
        const uIndex = jobYarnReceiveData.findIndex((data) => data.id === action.payload.id);
        jobYarnReceiveData.splice(uIndex, 1, { ...action.payload.data });
        
        return {
          ...state,
          jobYarnReceive: [ ...jobYarnReceiveData ],
          loading: false,
          error: null
        };
      case DELETE_JOB_YARN_RECEIVE:
        const jobYarnReceive = state.jobYarnReceive?.slice(0);
        const index = jobYarnReceive.findIndex((data) => data.id === action.id);
        if (index > -1) {
          jobYarnReceive.splice(index, 1);
        }
        return {
          ...state,
          jobYarnReceive: [...jobYarnReceive],
          loading: false,
          error: null
        }
      case JOB_YARN_RECEIVE_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case JOB_YARN_RECEIVE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default jobYarnReceiveReducer;
  